import styled from "styled-components";

export const Arrow = styled.button`
  background: ${(props) => props.theme.bgColor};
  border: 1px solid ${(props) => props.theme.borderColor};
  border-radius: 31px;
  transform: rotate(180deg);
  width: 50px;
  height: 50px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  & svg {
    & path {
      fill: ${(props) => props.theme.textColor};
    }
  }
`;

export const ArrowL = styled(Arrow)`
  left: -10px;
  & svg {
    margin-left: -2px;
  }
`;

export const ArrowR = styled(Arrow)`
  right: -10px;
  & svg {
    margin-right: -2px;
  }
`;
